import { API } from "aws-amplify";
import classificationsDisplayMap from "../constants/classificationsDisplayMap";

export const saveBusiness = async (businessId, params) => {
    return API.patch("business", "/business/"+businessId, {
        body: params,
    });
}

export const loadBusiness = async () => {
    return API.get("business", "/business/getDefaultBusiness");
}

/**
 * Helper method to determine the stamp image urls available to the business
 * @param {array} business 
 */
export const getStampsImageList = async (business) => {
    
    //NOTE: Always include a Small Business stamp for businesses to use
    var stampsImageList = [];
    var decalImageSrc = classificationsDisplayMap['Small Business'].image;
    var dokaSticker = getDokaStickerProperty(decalImageSrc);
    stampsImageList.push(dokaSticker);

    //Determine which additional stamps are available for this account
    if (business && business.classifications && business.classifications.length > 0) {
        business.classifications.forEach(classification => {
            //get Classification and determine stamp image
            //ignore "Small Business" classification since we'll always include a Small Business sticker 
            if (classification !== 'Small Business') {
                var decalImageSrc = classificationsDisplayMap[classification].image;
                var dokaSticker = getDokaStickerProperty(decalImageSrc);
                stampsImageList.push(dokaSticker);
            }
        });

    }
    return stampsImageList;
}

/** Helper method to determine the sticker property for stamps */
function getDokaStickerProperty(imageSrc) {
    return imageSrc;
    /* Image as a markup structure 
    (not working properly on mobile and safari, hence commenting out for now) 
    
    const stickerPositionRight = '40px';
    const stickerPositionBottom = '40px';
    const stickerDefaultWidth = '180px';
    const stickerDefaultHeight = '180px';
    
    //doka sticker property: https://pqina.nl/doka/docs/patterns/api/doka-instance/#using-stickers
    return ['image', { 
        right: stickerPositionRight,
        bottom: stickerPositionBottom,
        width: stickerDefaultWidth,
        height: stickerDefaultHeight,
        src: imageSrc,
        fit: 'contain'}];
    */
}